import React from 'react';
import { Laboratory } from '../../../../../../graphql/graphql';
import useTranslation from '../../../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './LaboratoryActivationTransferConsent.module.scss';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';

interface Props {
	onAcceptConsent: () => void;
	onRejectConsent: () => void;
	laboratory: Laboratory;
}

const LaboratoryActivationTransferConsent: React.FC<Props> = ({
	onAcceptConsent,
	onRejectConsent,
	laboratory,
}) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div>
				{t('component.laboratoryActivationTransferConsent.text', {
					companyName: laboratory.name,
				})}
			</div>
			<div className={styles.controls}>
				<Button
					onClick={onAcceptConsent}
					theme={Theme.GREEN}
					title='component.laboratoryActivationTransferConsent.acceptButton'
					fitContent
				/>
				<Button
					onClick={onRejectConsent}
					theme={Theme.RED}
					title='component.laboratoryActivationTransferConsent.rejectButton'
					fitContent
				/>
			</div>
		</div>
	);
};

export default LaboratoryActivationTransferConsent;
